import React from 'react';
import { Link, useParams } from 'react-router-dom';
import TermsOfService from './TermsOfService';
import TermsOfService_1_2 from './TermsOfService_1_2';
import TermsOfService_1_3 from './TermsOfService_1_3';
import { resolveTermsVersion, useTosConfig } from '../utils/termsConfig';

/**
 * Every Terms of Service version this build can show, oldest first. Each version keeps its own page
 * at /terms/<version> so an acceptance record's documentUrl always points at the exact text accepted;
 * /terms shows the current version (from shop-svc config).
 *
 * To publish a new version: add its component (e.g. TermsOfService_1_2.tsx) here and deploy, THEN
 * raise shop-svc's csai.agreements.terms-of-service.current-version. Never edit an existing version's
 * text in place. (shop-svc USER_AGREEMENTS_IMPLEMENTATION_PLAN.md, section 10.)
 */
export const TERMS_DOCUMENTS: Record<string, React.FC> = {
  '1.1': TermsOfService,
  '1.2': TermsOfService_1_2,
  '1.3': TermsOfService_1_3,
};

const TermsPage: React.FC = () => {
  const { version } = useParams<{ version?: string }>();
  const { currentVersion } = useTosConfig();
  const shown = resolveTermsVersion(version, currentVersion, Object.keys(TERMS_DOCUMENTS));

  if (!shown) {
    return (
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', color: 'var(--text-primary)' }}>
        <p>Terms of Service version {version} isn't available here.</p>
        <Link to="/terms" style={{ color: 'var(--primary-light)' }}>View the current Terms of Service</Link>
      </div>
    );
  }

  const Document = TERMS_DOCUMENTS[shown];
  return (
    <>
      {shown !== currentVersion && (
        <div style={{ maxWidth: '800px', margin: '24px auto 0', padding: '12px 20px', fontSize: '0.875rem',
                      color: 'var(--text-secondary)', border: '1px solid var(--border-light)', borderRadius: '8px' }}>
          This is version {shown} of our Terms of Service, kept for reference.{' '}
          <Link to="/terms" style={{ color: 'var(--primary-light)' }}>View the current Terms</Link>
        </div>
      )}
      <Document />
    </>
  );
};

export default TermsPage;
